import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * SEO component for per-page metadata + JSON-LD structured data.
 * Usage: <Seo title="..." description="..." canonical="..." jsonLd={obj} />
 */
export default function Seo({ title, description, canonical, image, jsonLd, type = "website" }) {
  const fullTitle = title ? `${title} | Giftopay` : "Giftopay — Sell Gift Cards Safely";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
